import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HashLocationStrategy, LocationStrategy, DatePipe } from '@angular/common';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { Logger, Options } from 'angular2-logger/core';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedService } from './shared/shared.service';
import { GuardModule } from './guard/guard.module';
import { SharedModule } from './shared/shared.module';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { StorageServiceModule } from 'angular-webstorage-service';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    DropDownListModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpModule,
    ToastModule.forRoot(),
    BrowserAnimationsModule,
    GuardModule,
    SharedModule,
    StorageServiceModule,
    MatFormFieldModule, 
    MatInputModule,
    ReactiveFormsModule
  ],
  providers: [
    Logger,
    Options,
    SharedService,
    DatePipe,
    {provide: LocationStrategy, useClass: HashLocationStrategy}
    ],
  bootstrap: [AppComponent]
})

export class AppModule {

  constructor(private logger: Logger) {
    this.logger.level = environment.logger;
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/app.module.ts